/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import { ThunkDispatch, ReduxState } from '@/types/redux'
import { getRegionId } from '@/lib/stackDeployments/selectors/fundamentals'
import { getTrustRelationships } from '@/reducers/trustManagement'
import { fetchTrustRelationshipsRequest } from '@/reducers/asyncRequests/registry'

import {
  fetchTrustRelationships,
  resetFetchTrustRelationships,
} from '../../../actions/trustManagement'

import DeploymentTrustRelationshipHeader from './DeploymentTrustRelationshipHeader'

import type { StateProps, DispatchProps, ConsumerProps } from './types'

const mapStateToProps = (state: ReduxState, { stackDeployment }: ConsumerProps): StateProps => {
  const regionId = getRegionId({ deployment: stackDeployment! })!

  return {
    environmentTrustRelationships: getTrustRelationships(state, regionId),
    fetchTrustRelationshipsRequest: fetchTrustRelationshipsRequest(state, regionId),
  }
}

const mapDispatchToProps = (
  dispatch: ThunkDispatch,
  { stackDeployment }: ConsumerProps,
): DispatchProps => {
  const regionId = getRegionId({ deployment: stackDeployment! })!

  return {
    fetchTrustRelationships: () =>
      dispatch(
        fetchTrustRelationships({
          regionId,
        }),
      ),
    resetFetchTrustRelationships: () => dispatch(resetFetchTrustRelationships(regionId)),
  }
}

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(DeploymentTrustRelationshipHeader)
